import "../css/style.scss";
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

/*---------top-level-comment---------------------------------------
import plugins
-----------------------*/
// gsap.registerPlugin(GSDevTools)
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)
gsap.registerPlugin(Observer)
gsap.registerPlugin(ScrollToPlugin)
// GSDevTools.create();

/*---------top-level-comment---------------------------------------
Custom Easing
-----------------------------------------------------------------*/
CustomEase.create("float", "M0,0 C0.126,0.382 0.18,0.874 0.338,1.022 0.53,1.202 0.637,0.935 1,1");
CustomEase.create("mutedFloat", "M0,0 C0.063,0.191 0.199,0.822 0.272,0.986 0.345,1.15 0.497,1.015 0.633,1 0.493,0.981 0.818,1.001 1,1 ");
CustomEase.create("slowly", "M0,0 C0.176,0.039 0.228,0.039 0.394,0.131 0.486,0.182 0.564,0.297 0.647,0.47 0.694,0.569 0.686,0.53 0.739,0.688 0.783,0.822 0.822,1.014 1,1")
CustomEase.create("water-drop", "M0,0 C0.059,0.073 0.144,0.135 0.201,0.34 0.24,0.483 0.259,0.578 0.303,0.647 0.401,0.799 0.488,0.793 0.522,0.793 0.63,0.793 0.616,0.779 0.7,0.8 0.77,0.817 0.834,0.8 1,0.779 ");
CustomEase.create("soft-accelerate", "M0,0 C0.126,-0.095 0.244,0.255 0.28,0.477 0.38,1.094 0.537,1.038 0.637,1.01 0.671,1 0.705,0.989 0.75,0.989 0.841,0.989 0.923,1 1,1 ")
CustomEase.create("medium-accelerate", "M0,0 C0.126,-0.095 0.381,0.229 0.417,0.451 0.517,1.068 0.58,1.028 0.68,1 0.714,0.99 0.705,0.989 0.75,0.989 0.841,0.989 0.923,1 1,1 ")
var bezierSoft = 'cubic-bezier(0.87, 0, 0.13, 1)';
var bezierFloat = 'cubic-bezier(.17,1.74,.57,.88)';

/*---------top-level-comment---------------------------------------
Offer Popup
-----------------------------------------------------------------*/
let offerPopup, offerCloseTriggers, offerPopupInner

document.addEventListener('DOMContentLoaded', () => {
    offerPopup = document.querySelector('.popup-offer');
    offerPopupInner = document.querySelector('.popup-offer .popup-inner');
    offerCloseTriggers = document.querySelectorAll('.popup-offer .close-trigger');
    offerCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => closeOfferPopup())
    })
    setTimeout(() => {
        openOfferPopup();
    }, 5000);
})

function openOfferPopup() {
    gsap.to(offerPopupInner, {
        display: 'flex',
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.inOut'
    })
    gsap.to(offerPopup, {
        display: 'flex',
        autoAlpha: 1,
        duration: 0.1,
        ease: 'power2.inOut'
    })
}

function closeOfferPopup() {
    gsap.to(offerPopup, {
        display: 'none',
        autoAlpha: 0,
        duration: 0.3,
        ease: 'power2.inOut'
    })
    gsap.to(offerPopupInner, {
        display: 'none',
        autoAlpha: 0,
        y: -15,
        duration: 0.3,
        ease: 'power2.inOut'
    })
}

/*---------top-level-comment---------------------------------------
Book Popup Functionality
-----------------------------------------------------------------*/
let bookPopup, bookBtns, bookPopupCloseTriggers, bookPopupInner;

document.addEventListener('DOMContentLoaded', () => {
    bookBtns = document.querySelectorAll('.book-popup-trigger');
    bookPopup = document.querySelector('.book-popup');
    bookPopupInner = document.querySelector('.book-popup .popup-inner');
    bookPopupCloseTriggers = document.querySelectorAll('.book-popup .close-trigger');
    attach_bookBtn_evtL();
})

function attach_bookBtn_evtL() {
    bookBtns.forEach(btn => bookBtn_evtL(btn));
    bookPopupCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => closeBookPopup())
    })
}

function bookBtn_evtL(btn) {
    btn.addEventListener('click', () => openBookPopup());
}

function openBookPopup() {
    gsap.to(bookPopupInner, {
        display: 'flex',
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.inOut'
    })
    gsap.to(bookPopup, {
        display: 'flex',
        autoAlpha: 1,
        duration: 0.1,
        ease: 'power2.inOut'
    })
}

function closeBookPopup() {
    gsap.to(bookPopup, {
        display: 'none',
        autoAlpha: 0,
        duration: 0.3,
        ease: 'power2.inOut'
    })
    gsap.to(bookPopupInner, {
        display: 'none',
        autoAlpha: 0,
        y: -15,
        duration: 0.3,
        ease: 'power2.inOut'
    })
}


/*--Debounce Function--*/
function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

/*---------top-level-comment---------------------------------------
FAQs Functionality
-----------------------------------------------------------------*/
/*--Scoped Vars--*/
let faqContent, faqItems, faqQuestions, faqAngles, faqAnswers, tabSection;

document.addEventListener('DOMContentLoaded', () => {
    faqContent = document.querySelector('.faq-content');
    if (!faqContent) return;
    faqItems = document.querySelectorAll('.faq-item');
    faqQuestions = faqContent.querySelectorAll('.faq-question');
    faqAngles = faqContent.querySelectorAll('.svg-angle-down');
    faqAnswers = faqContent.querySelectorAll('.faq-answer');
    tabSection = document.querySelector('.tab-section');

    faqFunction();
})

const faqV = {
    startDur: 0.501, endDur: 0.5, activeH: 'auto', inactiveH: 0, delay: 0.3, activeY: 0, inactiveY: -10, activeScale: 1, inactiveScale: 0.98, easing: 'power2.inOut'
}
const answerV = {
    startDur: 0.5, endDur: 0.4, delay: 0.3,
}

/*--FAQ Functionality--*/
function faqFunction() {
    faqObserver_create();
}

/*--Create FAQ Observer--*/
function faqObserver_create() {
    for (let faq of faqItems) {
        const question = faq.querySelector('.faq-question');
        Observer.create({
            target: question,
            type: 'touch, pointer',
            onClick: () => {
                faq_toggle(faq);
            }
        })
    }
}


/*--FAQ Tab Toggle--*/
function faq_toggle(faq) {
    const angle = faq.querySelector('.svg-angle-down');
    const answer = faq.querySelector('.faq-answer');
    const contentArea = answer.querySelector('content-area');
    const faqOpen = faq.classList.contains('faq-open');
    faq.classList.toggle('faq-open');
    // gsap.to(tabSection, {
    //     height: 'auto',
    //     duration: 0.4,
    //     ease: 'power2.inOut'
    // })
    gsap.to(angle, {
        rotate: faqOpen ? 0 : '180deg',
        duration: faqOpen ? faqV.endDur : faqV.startDur,
        ease: faqV.easing
    })
    gsap.to(answer, {
        height: faqOpen ? 0 : 'auto',
        autoAlpha: faqOpen ? 0 : 1,
        // delay: faqOpen ? faqV.delay : 0,
        duration: faqOpen ? faqV.endDur : faqV.startDur,
        ease: faqV.easing
    })
    gsap.to(contentArea, {
        y: faqOpen ? faqV.inactiveY : faqV.activeY,
        scale: faqOpen ? faqV.inactiveScale : faqV.activeScale,
        autoAlpha: faqOpen ? 0 : 1,
        delay: faqOpen ? 0 : answerV.delay,
        duration: answerV.startDur,
        ease: faqV.easing
    })
}

// /*---------top-level-comment---------------------------------------
// Slash Screen Animation
// -----------------------------------------------------------------*/
// let splashScreen, introMessage, splashLogo, htmlTag;

// document.addEventListener('DOMContentLoaded', ()=> {
//     splashScreen = document.querySelector('splash-screen');
//     splashLogo = document.querySelector('splash-screen img.logo');
//     htmlTag = document.querySelector('html');

//     splashEntrance();
// })

// // function splashEntrance() {
// //     gsap.to(splashScreen, {
// //         // autoAlpha: 0,
// //         display: 'none',
// //         duration: 1,
// //         delay: 1,
// //         ease: 'power2.in',
// //         y: '-100%'
// //     })
// //     gsap.set(htmlTag, {
// //         overflow: 'visible',
// //         delay: 1
// //     })

// //     gsap.to(splashLogo, {
// //         autoAlpha: 1,
// //         duration: 1.3,
// //         ease: 'soft-accelerate',
// //         y: 0
// //     })
// //     gsap.fromTo('section-container', {
// //         y: '100vh',
// //     },{
// //         delay: 1.1,
// //         duration: 1.4,
// //         autoAlpha: 1,
// //         y: 0,
// //         ease: 'power2.inOut',
// //         immediateRender: false
// //     })
// //     gsap.fromTo('.first-transition', {
// //         y: -40,
// //         autoAlpha: 0,
// //     },{
// //         y: 0,
// //         autoAlpha: 1,
// //         stagger: 0.4,
// //         duration: 1,
// //         ease: 'slow-accelerate',
// //         delay: 2,
// //     })
// // }

// function splashEntrance() {
//     const tl = gsap.timeline();
//     tl.to(splashLogo, { autoAlpha: 1, duration: 1.3, ease: 'soft-accelerate' })
//     tl.to(splashScreen,{ display:'none', duration:1, ease:'power2.inOut', y:'-100%' }, ">-0.3")
//     tl.fromTo('section-container', { y: '100vh' },{ duration:1.4, autoAlpha:1, y:0, ease:'power2.inOut', immediateRender: false}, "<")
//     tl.set(htmlTag, {overflow: 'visible', delay:1}, 0)
// }


/*---------top-level-comment---------------------------------------
Scroll Trigger Transitions
-----------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    apply_blockScrollTrigger();
    apply_contentAreaTrigger();
    apply_fadeIn();
    staggerAnim();
})

function blockScrollTrigger(target) {
    gsap.to(target, {
        scrollTrigger: {
            trigger: target,
            start: 'top bottom',
        },
        y: 0,
        autoAlpha: 1,
        scale: 1,
        ease: 'soft-accelerate',
        duration: 1.3
    })
}

function apply_blockScrollTrigger() {
    const blocks = document.querySelectorAll('.tt');
    blocks.forEach(block => {
        blockScrollTrigger(block);
    })
}

function contentAreaTrigger(content) {
    gsap.to(content, {
        scrollTrigger: {
            trigger: content,
            start: 'top 80%',
            end: 'top 50%',
        },
        autoAlpha: 1,
        x: 0,
        duration: 1.4,
        ease: 'water-drop'
    })
}
function fadeInAnim(fade) {
    gsap.to(fade, {
        scrollTrigger: {
            trigger: fade,
            start: 'top 90%',
        },
        opacity: 1,
        x: 0,
        duration: 1.4,
        ease: 'medium-accelerate'
    })
}

function apply_contentAreaTrigger() {
    const contentAreas = document.querySelectorAll('content-area');
}

function apply_fadeIn() {
    const fadeInRights = document.querySelectorAll('.fir');
    const fadeInLefts = document.querySelectorAll('.fil');
    fadeInRights.forEach(fade => {
        fadeInAnim(fade);
    })
    fadeInLefts.forEach(fade => {
        fadeInAnim(fade);
    })
}

function staggerAnim() {
    const staggerItemsParent = document.querySelectorAll('.staggerParent');
    const staggerItems = document.querySelectorAll('.staggerItem');
    gsap.to(staggerItems, {
        scrollTrigger: {
            trigger: staggerItemsParent,
            start: 'top 90%'
        },
        opacity: 1,
        y: 0,
        stagger: 0.2,
        duration: 1.3,
        ease: 'power2.inOut'
    })
}

/*---------top-level-comment---------------------------------------
Lenis
-----------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
    // Initialize Lenis
    const lenis = new Lenis({
        lerp: 0.8,
        wheelMultiplier: 1.2
    });

    // Use requestAnimationFrame to continuously update the scroll
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
});

/*---------top-level-comment---------------------------------------
Per Block Transitions
-----------------------------------------------------------------*/
let anim_slideLeft, anim_slideRight, anim_fade, anim_scaleDown, anim_scaleUp

document.addEventListener('DOMContentLoaded', () => {
    anim_slideLeft = document.querySelector('.anim_slideLeft');
    anim_slideRight = document.querySelector('.anim_slideRight');
    anim_fade = document.querySelector('.anim_fade');
    anim_scaleDown = document.querySelector('.anim_scaleDown');
})

/*---------top-level-comment---------------------------------------
Package Popup Functionality
-----------------------------------------------------------------*/
let packagePopup, packageBtns, packagePopupCloseTriggers, packagePopupInners, targetFormID;

document.addEventListener('DOMContentLoaded', () => {
    packageBtns = document.querySelectorAll('.packages .package-btn');
    packagePopup = document.querySelector('.package-popup');
    packagePopupInners = document.querySelectorAll('.package-popup .popup-inner');
    packagePopupCloseTriggers = document.querySelectorAll('.package-popup .close-trigger');
    attach_package_evtL();
})

function attach_package_evtL() {
    packageBtns.forEach(btn => {
        targetFormID = btn.getAttribute('data-form-id');
        console.log('targetFormID:', targetFormID);
        package_evtL(btn, targetFormID)

    })
    packagePopupCloseTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => closePackagePopup())
    })
}

function package_evtL(btn, targetFormID) {
    btn.addEventListener('click', () => openPackagePopup(targetFormID));
}

function openPackagePopup(targetFormID) {
    console.log('targetFormID:', targetFormID);
    const inner = document.querySelector(`.package-popup .popup-inner[data-form-id="${targetFormID}"]`)
    gsap.to(inner, {
        display: 'flex',
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.inOut'
    })
    gsap.to(packagePopup, {
        display: 'flex',
        autoAlpha: 1,
        duration: 0.1,
        ease: 'power2.inOut'
    })
}

function closePackagePopup() {
    gsap.to(packagePopup, {
        display: 'none',
        autoAlpha: 0,
        duration: 0.3,
        ease: 'power2.inOut'
    })
    gsap.to(packagePopupInners, {
        display: 'none',
        autoAlpha: 0,
        y: -15,
        duration: 0.3,
        ease: 'power2.inOut'
    })
}

/*---------top-level-comment---------------------------------------
Tooltip Hero functionality
-----------------------------------------------------------------*/
let hero_tooltipTrigger, hero_tooltipBubble, tooltipState;
document.addEventListener('DOMContentLoaded', () => {
    hero_tooltipTrigger = document.querySelector('section.hero .tooltip-comp img');
    hero_tooltipBubble = document.querySelector('section.hero .tooltip-comp content-area.tooltip');
    tooltipState = 0;
    hero_tooltipTrigger.addEventListener('click', () => toggle_tooltip(tooltipState));
})

function toggle_tooltip() {
    console.log(tooltipState, 'tts');
    if (tooltipState === 0) {
        hero_tooltipBubble_animation(tooltipState)
        tooltipState = 1;
        console.log(tooltipState, 'tts');
        return tooltipState;
    }
    hero_tooltipBubble_animation(tooltipState)
    tooltipState = 0;
}

function hero_tooltipBubble_animation(state) {
    gsap.to(hero_tooltipBubble, {
        display: state ? 'none' : 'flex',
        autoAlpha: state ? 0 : 1,
        ease: 'soft-accelerate',
        duration: 0.5
    })
}
/*---------top-level-comment---------------------------------------
Tooltip The Process functionality
-----------------------------------------------------------------*/
let theProcess_tooltipTrigger, theProcess_tooltipBubble, theProcess_tooltipState;
document.addEventListener('DOMContentLoaded', () => {
    theProcess_tooltipTrigger = document.querySelector('section.the-process .tooltip-comp img');
    theProcess_tooltipBubble = document.querySelector('section.the-process .tooltip-comp content-area.tooltip');
    theProcess_tooltipState = 0;
    theProcess_tooltipTrigger.addEventListener('click', () => theProcess_toggle_tooltip(theProcess_tooltipState));
})

function theProcess_toggle_tooltip() {
    console.log(theProcess_tooltipState, 'tts');
    if (theProcess_tooltipState === 0) {
        theProcess_tooltipBubble_animation(theProcess_tooltipState)
        theProcess_tooltipState = 1;
        console.log(theProcess_tooltipState, 'tts');
        return theProcess_tooltipState;
    }
    theProcess_tooltipBubble_animation(theProcess_tooltipState)
    theProcess_tooltipState = 0;
}

function theProcess_tooltipBubble_animation(state) {
    gsap.to(theProcess_tooltipBubble, {
        display: state ? 'none' : 'flex',
        autoAlpha: state ? 0 : 1,
        ease: 'soft-accelerate',
        duration: 0.5
    })
}

/*---------top-level-comment---------------------------------------
Process Functionality
-----------------------------------------------------------------*/
let pstepNames, pstepContents, pstepImages, pcontentContainer, pstepNames_names, pstepNames_numbers
let prev_index = 0;

document.addEventListener('DOMContentLoaded', () => {
    pstepNames = document.querySelectorAll('.the-process .step-name');
    pstepNames_names = document.querySelectorAll('.the-process .step-name .name');
    pstepNames_numbers = document.querySelectorAll('.the-process .step-name .number');
    pstepContents = document.querySelectorAll('.the-process .step-content');
    pstepImages = document.querySelectorAll('.the-process .step-image');
    pcontentContainer = document.querySelector('.the-process .content-container')
    attach_stepEVTL();
    set_firstStep();
})

function attach_stepEVTL() {
    for (let name of pstepNames) {
        let index = parseInt(name.dataset.index) - 1;
        name.addEventListener('click', () => toggle_step(index))
    }
}

function set_firstStep() {
    gsap.set(pstepContents[0], {
        autoAlpha: 1,
        y: 0,
        pointerEvents: 'all'
    })
    gsap.set(pstepImages[0], {
        autoAlpha: 1
    })
}

function toggle_step(index) {
    console.log('prev_index', prev_index);
    console.log('index', index);
    let original_width = pstepNames_numbers[index].getBoundingClientRect().width;
    console.log('originalwidth', original_width);

    if (prev_index !== index) {
        gsap.to(pstepContents[prev_index], {
            autoAlpha: 0,
            y: -20,
            pointerEvents: 'none',
            ease: 'soft-accelerate',
            duration: 0.8,
        })
        gsap.to(pstepNames[prev_index], {
            autoAlpha: 0.5,
            ease: 'soft-accelerate',
            duration: 0.8
        })
        gsap.to(pstepImages[prev_index], {
            autoAlpha: 0,
            ease: 'soft-accelerate',
            duration: 0.8
        })
    }
    gsap.to(pstepNames[index], {
        autoAlpha: 1,
        ease: 'soft-accelerate',
        duration: 0.8,
    })
    gsap.to(pstepContents[index], {
        autoAlpha: 1,
        y: 0,
        pointerEvents: 'all',
        ease: 'soft-accelerate',
        duration: 0.8,
    })
    gsap.to(pstepImages[index], {
        autoAlpha: 1,
        ease: 'soft-accelerate',
        duration: 0.8,
    })

    prev_index = index
}


(function () {
    document.addEventListener('DOMContentLoaded', function () {
        // Initialize every gallery on the page independently
        document.querySelectorAll('.gallery').forEach(initGallery);

        function initGallery(gallery) {
            const selectedImg = gallery.querySelector('.selected-image img');
            const items = Array.from(gallery.querySelectorAll('.gallery-item'));
            const prevBtn = gallery.querySelector('.gallery-navigation .prev');
            const nextBtn = gallery.querySelector('.gallery-navigation .next');
            const counterSpan = gallery.querySelector('.gallery-navigation .current-image');
            const visibleCount = 3;

            if (!items.length) return;

            let start = 0;        // Index of the first visible thumbnail in the window
            let activeIndex = 0;  // Index of the currently selected image

            // Update the counter text (e.g., "3 / 10 images")
            function updateCounter() {
                if (!counterSpan) return;
                counterSpan.textContent = `${activeIndex + 1} / ${items.length} images`;
            }

            // Update the large selected image with fade-in/out animation
            function updateSelectedImage(index) {
                const imgEl = items[index].querySelector('img');
                if (!imgEl || !selectedImg) return;

                const newSrc = imgEl.getAttribute('src');
                const newAlt = imgEl.getAttribute('alt') || '';

                // Smooth fade effect using transitionend (with once:true to avoid stacking listeners)
                selectedImg.classList.add('fade-out');
                selectedImg.addEventListener('transitionend', function handler() {
                    selectedImg.src = newSrc;
                    selectedImg.alt = newAlt;
                    selectedImg.classList.remove('fade-out');
                    selectedImg.classList.add('fade-in');
                    setTimeout(() => selectedImg.classList.remove('fade-in'), 300);
                }, { once: true });

                // Highlight active thumbnail
                items.forEach(it => it.classList.remove('active'));
                items[index].classList.add('active');

                activeIndex = index;
                updateCounter();
                ensureActiveInWindow();
            }

            // Show only the current "window" of 3 thumbnails
            function renderWindow() {
                const n = items.length;
                items.forEach((item, i) => {
                    const inWindow = (i - start + n) % n < visibleCount;
                    item.style.display = inWindow ? '' : 'none';
                });
            }

            // Ensure the active thumbnail stays visible inside the 3-item window
            function ensureActiveInWindow() {
                const n = items.length;
                const pos = (activeIndex - start + n) % n;
                if (pos >= visibleCount) {
                    // Shift start so active image moves into view at the end of the window
                    start = (activeIndex - (visibleCount - 1) + n) % n;
                    renderWindow();
                } else if (pos < 0) {
                    // Shift start forward if active index is before current window
                    start = activeIndex;
                    renderWindow();
                }
            }

            // Go to the next image (carousel behavior)
            function goNext() {
                const n = items.length;
                start = (start + 1) % n;
                activeIndex = (activeIndex + 1) % n;
                renderWindow();
                updateSelectedImage(activeIndex);
            }

            // Go to the previous image (carousel behavior)
            function goPrev() {
                const n = items.length;
                start = (start - 1 + n) % n;
                activeIndex = (activeIndex - 1 + n) % n;
                renderWindow();
                updateSelectedImage(activeIndex);
            }

            // Event listeners
            items.forEach((item, i) => {
                item.addEventListener('click', () => updateSelectedImage(i));
            });
            nextBtn?.addEventListener('click', goNext);
            prevBtn?.addEventListener('click', goPrev);

            // Initialize the gallery
            const currentSrc = selectedImg?.getAttribute('src');
            const found = currentSrc
                ? items.findIndex(it => it.querySelector('img')?.getAttribute('src') === currentSrc)
                : -1;

            // If the selected image already exists, sync it; otherwise, select the first one
            if (found >= 0) {
                activeIndex = found;
            } else {
                activeIndex = 0;
                updateSelectedImage(0);
            }

            renderWindow();
            ensureActiveInWindow();
            updateCounter();
        }
    });
})();

